export const Error_Number_SpecialCharacter = 1;
export const Error_Two_Letters = 2;
export const Error_Min_Maj_Letters = 3;
export const Success = 0;